<template>
  <v-card width="256" class="mx-auto" style="box-shadow: none !important">
    <v-list-item>
      <div class="p-2">
        <img src="../assets/images/kriyana.png" width="90%" />
      </div>
      <v-list-item-content>
        <v-list-item-title class="text-h6">
          {{ name }}
        </v-list-item-title>
        <v-list-item-subtitle> +91 {{ mobile }} </v-list-item-subtitle>
      </v-list-item-content>
    </v-list-item>

    <v-divider></v-divider>

    <v-list dense nav>
      <v-list-item
        v-for="item in items"
        :key="item.title"
        :to="item.to"
        link
        :class="item.class"
      >
        <v-list-item-icon>
          <v-icon>{{ item.icon }}</v-icon>
        </v-list-item-icon>

        <v-list-item-content>
          <v-list-item-title>{{ item.title }}</v-list-item-title>
        </v-list-item-content>
      </v-list-item>
    </v-list>
    <div class="col-11 auto mt-3">
      <p>
        Available Points :<span>{{ points_available }}</span>
      </p>
      <p>
        Referral Link :<span id="ref_link" style="display: none"
          >https://www.kriyana.com/vue/#/?{{ storeSelected }}_{{
            referral_code
          }}</span
        ><span>{{ referral_code }}</span>
        <v-icon @click="copyRefLink()">content_copy</v-icon>
      </p>
    </div>
  </v-card>
</template>
<script>
import axios from "axios";
import ApiList from "../components/ApiList";
export default {
  mixins: [ApiList],
  data() {
    return {
      items: [
        { title: "Home", icon: "home", to: "/home", class: "hide-links" },
        {
          title: "Orders",
          icon: "mdi-history",
          to: "/orders",
          class: "hide-links",
        },
        {
          title: "Payments",
          icon: "account_balance_wallet",
          to: "/payments",
          class: "hide-links",
        },

        { title: "Edit Profie", icon: "person", to: "/profile" },
        // { title: "Choose Another Store", icon: "mdi-view-dashboard", to: "" },
        { title: "Manage Address", icon: "person_pin_circle", to: "/address" },
        { title: "About Store", icon: "info", to: "/about" },
        {
          title: "Developer Contact",
          icon: "developer_mode",
          to: "/developer",
        },
        { title: "Logout", icon: "logout", to: "/logout" },
      ],
      right: null,
      name: "",
      mobile: "",
      referral_code: "",
      points_available: 0,
      storeSelected: "",
    };
  },
  mounted() {
    this.loadData();
  },
  methods: {
    loadData() {
      this.name = localStorage.name;
      this.mobile = localStorage.tmp_mobile;
      let store = localStorage.getItem("selected_db");
      console.log(store);
      this.storeSelected = window.btoa(store);
      this.storeSelected = this.storeSelected.replace("==", "");
      this.customerDetails();
    },
    copyRefLink() {
      var copyText = document.getElementById("ref_link").innerText;
      navigator.clipboard.writeText(copyText);
      alert("Referral Link Copied");
    },
    customerDetails() {
      this.newUrl = this.apis.apiUrl + this.apis.customerListUrl;
      this.param = {
        params: {
          token: localStorage.token,
          customer_id: this.customer_id,
        },
      };
      axios.get(this.newUrl, this.param).then((response) => {
        // console.log(response)
        // this.orderList = []
        this.customerDetail = response.data[0];
        if (response.data[0].gender == "Male") {
          this.isMale = true;
          this.isFemale = false;
        } else if (response.data[0].gender == "Female") {
          this.isMale = false;
          this.isFemale = true;
        }
        this.name = response.data[0].name;
        this.mobile = response.data[0].mobile;
        this.email = response.data[0].email;
        this.gender = response.data[0].gender;
        this.old_mobile = response.data[0].mobile;
        this.referral_code = response.data[0].referral_code;
        this.points_available = response.data[0].points_available;
        // console.log("response : "+JSON.stringify(response.data[0]));
      });
    },
  },
};
</script>
<style>
@media only screen and (max-width: 900px) {
  .hide-links {
    display: none !important;
  }
}
</style>